import * as actions from './actions';
import { buildName, withRootExtension, withAll, createRouteMatcher } from 'piral-core';
import { DefaultBreadbrumbItem, DefaultBreadcrumbsContainer } from './default';
import { Breadcrumbs } from './Breadcrumbs';
function getMatcher(settings) {
    if (settings.matcher instanceof RegExp) {
        return settings.matcher;
    }
    else if (typeof settings.matcher === 'string') {
        return createRouteMatcher(settings.matcher);
    }
    else {
        return createRouteMatcher(settings.path);
    }
}
function getBreadcrumbs(items) {
    const breadcrumbs = {};
    let i = 0;
    for (const settings of items) {
        breadcrumbs[`global-${i++}`] = {
            pilet: undefined,
            matcher: getMatcher(settings),
            settings,
        };
    }
    return breadcrumbs;
}
function withBreadcrumbs(breadcrumbs) {
    return (state) => ({
        ...state,
        components: {
            BreadcrumbItem: DefaultBreadbrumbItem,
            BreadcrumbsContainer: DefaultBreadcrumbsContainer,
            ...state.components,
        },
        registry: {
            ...state.registry,
            breadcrumbs,
        },
    });
}
/**
 * Creates the Pilet API extension for activating breadcrumbs support.
 */
export function createBreadcrumbsApi(config = {}) {
    const { breadcrumbs = [] } = config;
    return (context) => {
        context.defineActions(actions);
        context.dispatch(withAll(withBreadcrumbs(getBreadcrumbs(breadcrumbs)), withRootExtension('piral-breadcrumbs', Breadcrumbs)));
        const registerBcs = (bcs) => {
            context.registerBreadcrumbs(bcs);
            return () => context.unregisterBreadcrumbs(Object.keys(bcs));
        };
        return (_, target) => {
            const pilet = target.name;
            let next = 0;
            const appendBc = (bcs, name, settings) => {
                const id = buildName(pilet, name);
                bcs[id] = {
                    pilet,
                    matcher: getMatcher(settings),
                    settings,
                };
                return bcs;
            };
            return {
                registerBreadcrumbs(values) {
                    const bcs = {};
                    for (const value of values) {
                        const { name = next++, ...settings } = value;
                        appendBc(bcs, name, settings);
                    }
                    return registerBcs(bcs);
                },
                registerBreadcrumb(name, settings) {
                    if (typeof name !== 'string') {
                        settings = name;
                        name = next++;
                    }
                    const bcs = appendBc({}, name, settings);
                    return registerBcs(bcs);
                },
                unregisterBreadcrumb(name) {
                    const id = buildName(pilet, name);
                    context.unregisterBreadcrumbs([id]);
                },
            };
        };
    };
}
//# sourceMappingURL=create.js.map